import type { ReactNode } from 'react'

const TONES = {
    warning: 'bg-warning-soft text-warning-soft-foreground',
    success: 'bg-success-soft text-success-soft-foreground',
    info: 'bg-surface-secondary text-foreground-muted',
} as const

/** A notice box of the review drawer (v17 `.notice`): a soft fill, no border (DS v2), yellow for a warning, green for a match, grey for a plain note. */
export const ReviewNotice = ({ tone, children }: { tone: keyof typeof TONES; children: ReactNode }) => (
    <div className={`my-4 rounded-xl p-3 text-xs leading-relaxed ${TONES[tone]}`}>{children}</div>
)

/** A section label of the review drawer: the DS v2 Label (11px, semibold, uppercase, wider tracking), muted. */
export const SectionLabel = ({ children }: { children: ReactNode }) => (
    <h4 className="mb-3 mt-6 text-[11px] font-semibold uppercase tracking-wider text-foreground-muted">{children}</h4>
)
